import UIFacade from "@baseUI/UIFacade";
import UISignals from "@baseUI/controllers/UISignals";
import UIBaseComponent from "@baseUI/component/base/UIBaseContainer";
import UICreatorComponent from "@baseUI/utils/UICreatorComponent";
import UICreatorText from "@baseUI/utils/UICreatorText";


export default class ActiveBets extends UIBaseComponent {

  constructor() {
    super()
    this.init()
  }

  init() {
    const panel = UICreatorComponent.addContainer(this, {x: 0, y: 0})
    UICreatorComponent.addElement('BetPanelMobilePortrait.png', panel, [0, 0])

    // Adding hit area especially to the minus button because it's too small
    const minusHitArea = new PIXI.Rectangle(-50,-30,100, 60)
    this.minusButton = UICreatorComponent.addListenerButton('mobileMinus_BUTTON', 'minus', panel, [100, 50], minusHitArea)

    this.plusButton = UICreatorComponent.addListenerButton('mobilePlus_BUTTON', 'plus', panel, [400, 50])
    UICreatorText.addElementTextName('mobileBet_TEXT', panel, [250, 20])
    this.bet = UICreatorText.addElementDynamicTextName('mobileBet_DYNAMIC', panel, [250, 60])
    UISignals.setBet.add( (value)=>{
      this.bet.text = (value === '') ?  0 : value
    })

    const possibleBets = UIFacade.model.setPossibleBets
    const setActiveButton = (index) => {
      this.activeIndex = index
     // UIFacade.model.currentBetIndex = this.activeIndex
    }

    this.minusButton.on('tapButton', ()=>{
      if(this.activeIndex - 1 >= 0) {
        setActiveButton(this.activeIndex - 1)
      }
    })
    this.plusButton.on('tapButton', ()=>{
      if(this.activeIndex + 1 <= possibleBets.length - 1) {
        setActiveButton(this.activeIndex + 1)
      }
    })

    setActiveButton(UIFacade.model.currentBetIndex)
  }

  set enable(value) {
    this._enable = value
    this.interactive = value
    this.interactiveChildren = value
    // this.minusButton.visible = value
    // this.plusButton.visible = value
  }

  get enable() {
    return this._enable
  }
}
